import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import {
  ButtonStyled,
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  CardTextOnlyContainer,
  GridContainerStyled,
} from "./styles";

export default function FreeStartHere(props) {
  const [solutions, setSolutions] = useState([]);
  const isMobile = useMediaQuery("(max-width:1200px)");

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    // const response = await dispatch(fetchHiredlyXContent(query));

    const response = content_my;

    const { secondCardSection } = response || {};
    setSolutions(secondCardSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Claim my free post";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerInfoDialog() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "post_for_free_start_here",
    });
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <CardContainer>
        <CardListContainer>
          <CardImage src={solutions?.coverImage?.data?.attributes?.url} />

          <CardTextContainer>
            <CardTextOnlyContainer>
              <CardText type={"title"}>Careers Start Here</CardText>
              <CardText type={"desc"}>
                For many young Malaysians, jobs in Retail, Food & Beverage, and
                Hospitality are the <b>first step into the workforce.</b> These
                roles build the work ethic, experience, and people skills that
                shape future careers.
                <br />
                By posting these jobs on Hiredly, you’re giving youth:
                <br />
                <p>
                  <CheckCircleIcon height={24} width={24} />A chance to enter
                  the workforce with confidence
                </p>
                <p>
                  <CheckCircleIcon height={24} width={24} />
                  Skills they can carry into future roles
                </p>
                <p>
                  <CheckCircleIcon height={24} width={24} />A pathway into
                  executive and professional careers
                </p>
              </CardText>
              <CardText type={"desc"}>
                This isn’t just a free posting — it’s a way to strengthen
                Malaysia’s youth employment pipeline.
              </CardText>
            </CardTextOnlyContainer>

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "left",
              }}
            >
              <ButtonStyled onClick={triggerInfoDialog}>
                {buttonCTA}
              </ButtonStyled>
            </div>
          </CardTextContainer>
        </CardListContainer>
      </CardContainer>
    </GridContainerStyled>
  );
}
